import { registerPlugin } from '@capacitor/core';
import type { QToolPlugin } from '@/native/plugins/QTool/definitions';

const QTool = registerPlugin<QToolPlugin>('QTool', {
  web: () => import('./web').then((m) => new m.QToolWeb()),
});

export * from './definitions';
export { QTool };
